import React from 'react'
import { Box } from '@material-ui/core'

import useStyles from './styles'

const BrowserToolbar = () => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      {[1, 2, 3].map((dot) => (
        <Box key={dot} className={classes.dot} />
      ))}
      <Box className={classes.addressBar} />
    </Box>
  )
}

export default BrowserToolbar
